import DashboardListContainer from './dashboardListContainer';
export default DashboardListContainer;